module.exports = __webpack_public_path__ + "img/one.5b884812.png";